import { UserProfile } from '../../../api/api-types';
import { HardwareForForm } from '../Dashboard';

export const buildEmail = (
  profile: UserProfile,
  hardware: HardwareForForm[]
) => {
  const sortedHardware = [...hardware].sort((item1, item2) =>
    item1.serial.localeCompare(item2.serial)
  );
  let message = `${profile.name} from ${profile.company.companyName} has proposed the following changes to departmental hardware:\n\n`;
  for (const item of sortedHardware) {
    if (item.department) {
      message += `\t${item.serial}: ${item.department.departmentName}\n`;
    } else {
      message += `\t${item.serial}: None\n`;
    }
  }
  return message;
};
